import PropTypes from 'prop-types';
import React from 'react';
import { Generic } from 'app/components/shared/GenericMessage';

import './ToastMessage.scss';

const ToastMessage = ({ className = '', ...props }) => {
  const classNames = `cp-toast-message ${className}`;

  return (
    <div className={classNames}>
      <Generic {...props} />
    </div>
  );
};

ToastMessage.propTypes = {
  clearMessages: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default ToastMessage;
